
export enum ProductServiceType{
    PRODOTTO, SERVIZIO, SMARTPHONE
}
export enum ProductServiceLandingPageType{
    PAGEID, URL
}
export enum ProductServiceUrlClickAndCollectType{
    FISSA_APPUNTAMENTO = "FISSA_APPUNTAMENTO", 
    SIM = "SIM", 
    SMARTPHONE = "SMARTPHONE"
}

export class ProductServiceRequestList{
    dimPagina: number;
    numeroPagina: number;
    
}

export class ProductServiceRequest{
    index: number;
    dataSheet: string;
    documentId: number;
    expirationTime: string;
    expirationDay: string;
    iconId: number;
    landingPageService: string;
    landingPageType: ProductServiceLandingPageType;
    legalNotice: string;
    offerInformation: string;
    seoDescription: string;
    seoId: string;
    seoTitle: string;
    serviceDescription: string;
    serviceName: string;
    analyticsCode : string;
    startDay: string;
    startTime: string;
    type: ProductServiceType;
    urlBookAndCollect: string;
    urlClickAndCollectType: ProductServiceUrlClickAndCollectType;
    
}

export class ProductServiceRequestPublish{
    id:number;
    published: boolean;
    
}

export class ProductServiceRequestSearch{
    pageNumber: number;
    pageSize: number;
    published: boolean;
    serviceName: string;
    sortBy: string;
    
}
